import { map } from 'lodash'

export const useFunctionProxy = (nodeKey) => {
  let treeObj: any

  const setTreeInstance = (object) => {
    treeObj = object
  }

  /**
   * 获取勾选的节点集合
   * @param {Boolean} onlyLeaf 只返回选中的叶子节点
   */
  const getCheckedNodes = (onlyLeaf = false) => {
    if (onlyLeaf) {
      return treeObj.getCheckedNodes(true).filter(node => !node.isParent && !node.getCheckStatus().half)
    } else {
      return treeObj.getCheckedNodes(true).filter(node => !node.getCheckStatus().half)
    }
  }

  /**
   * 获取勾选的节点集合
   * @param {Boolean} onlyLeaf 只返回选中的叶子节点
   */
  const getCheckedKeys = (onlyLeaf = false) => {
    if (nodeKey) {
      const checkedNodes = getCheckedNodes(onlyLeaf)
      return map(checkedNodes, nodeKey)
    } else {
      return []
    }
  }

  /**
   * 获取半勾选的节点集合
   */
  const getHalfCheckedNodes = () => {
    return treeObj.getCheckedNodes(true).filter(node => node.getCheckStatus().half)
  }

  /**
   * 获取半勾选的节点集合
   */
  const getHalfCheckedKeys = () => {
    const checkedNodes = getHalfCheckedNodes()
    return map(checkedNodes, nodeKey)
  }

  /**
   * 获取当前被选中节点的
   */
  const getSelectedNodes = () => {
    return treeObj.getSelectedNodes()
  }

  /**
   * 获取当前被选中节点的 key，若没有节点被选中则返回 `undefined`
   */
  const getSelectedKeys = () => {
    const selectNodes = getSelectedNodes()
    if (nodeKey) {
      return selectNodes
    } else {
      return []
    }
  }

  /**
   * 通过 key 获取节点
   * @param key
   */
  const getNode = (key) => {
    if (nodeKey) {
      const nodes = getNodes([key])
      return nodes.length > 0 ? nodes[0] : {}
    } else {
      return {}
    }
  }

  const getNodes = (keys) => {
    return treeObj.getNodesByFilter((node) => keys.includes(node[nodeKey]))
  }

  /**
   * 更新某节点数据
   * @param key
   * @param data
   */
  const updateNode = (key, data) => {
    const node = getNode(key)
    Object.assign(node, data)
    treeObj.updateNode(node)
  }

  /**
   * 展开指定节点
   * @param keys
   */
  const expandNode = (keys) => {
    const expandNodes = getNodes(keys)
    expandNodes.forEach(node => {
      treeObj.expandNode(node, true, false, false)
    })
  }

  /**
   * 添加到指定节点
   * @param data 节点
   * @param parentkey 父节点Key
   */
  const appendNode = (data, parentkey) => {
    const node = getNode(parentkey)
    treeObj.addNodes(node, data)
  }

  /**
   * 删除指定节点
   * @param key
   */
  const removeNode = (key) => {
    const node = getNode(key)
    treeObj.removeNode(node)
  }

  /**
   * 设置勾选节点
   * @param keys
   */
  const setCheckedNodes = (keys: any[], status = true) => {
    const checkNodes = getNodes(keys)
    checkNodes.forEach(node => {
      treeObj.checkNode(node, status, true)
      // @ts-ignore
      treeObj.expandNode(node.isParent ? node : node.getParentNode(), node.isParent ? status : true, false, false)
    })
  }

  /**
   * 通过 key 设置某个节点的勾选状态
   * @param key
   */
  const setChecked = (key: string, status = true) => {
    setCheckedNodes([key], status)
  }

  /**
   * 设置选中节点
   * @param keys
   */
  const setSelectedNodes = (keys: any[]) => {
    const selectNodes = getNodes(keys)
    selectNodes.forEach(node => {
      treeObj.selectNode(node, false, true)
    })
  }

  /**
   * 通过 key 设置某个节点的当前选中状态
   * @param key
   */
  const setSelected = (key: string) => {
    setSelectedNodes([key])
  }

  /**
   * 勾选所有节点
   */
  const checkAll = () => {
    treeObj.checkAllNodes(true)
  }

  /**
   * 清除所有节点的选中状态
   */
  const clearAllChecked = () => {
    treeObj.checkAllNodes(false)
  }

  return {
    setTreeInstance,
    getCheckedNodes,
    getCheckedKeys,
    getHalfCheckedNodes,
    getHalfCheckedKeys,
    setCheckedNodes,
    setChecked,
    getSelectedNodes,
    getSelectedKeys,
    setSelectedNodes,
    setSelected,
    getNode,
    updateNode,
    expandNode,
    appendNode,
    removeNode,
    checkAll,
    clearAllChecked
  }
}

